module.exports = __webpack_public_path__ + "static/img/fish32.daff8d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish32.png
// module id = RVNP
// module chunks = 0